module.exports = __webpack_public_path__ + "static/media/aztec_gold_megaways.isoftbet.00f97414.jpeg";